import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DataIngestionState } from './reducers/data-ingestion.reducer';

export const dataIngestionStateKey = 'data-ingestion';
const dataIngestionState = createFeatureSelector<DataIngestionState>(dataIngestionStateKey);
export const selectDataIngestionState = createSelector(dataIngestionState, (state) => state);
